<template>
	<base-modal
		ref="$modal"
		:title="$t('finances')"
	>
		<template #header-right>
			<project-finance-summary :project="project" />
		</template>

		<div class="finance-expand">
			<project-finance-section
				:project="project"
				:project-id="project?.Id ?? 0"
				:finance-access="project?.FinanceAccess"
				:expanded="true"
				@changed="emit('changed')"
			/>
		</div>
	</base-modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import ProjectFinanceSection from "@/components/main/project-block-page/finance/ProjectFinanceSection.vue";
import ProjectFinanceSummary from "@/components/main/project-block-page/finance/ProjectFinanceSummary.vue";
import { projectPageStore } from "@/store/project-page";

const projectStore = projectPageStore()

const project = computed(() => projectStore.openedProject)

const emit = defineEmits<{
	(e: 'changed'): void,
}>()

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)

const onOpen = () => $modal.value?.onOpen()
const onClose = () => $modal.value?.onClose()

defineExpose({ onOpen, onClose })
</script>

<style scoped lang="scss">
.finance-expand {
	height: 100%;
	min-height: 0;
	padding: 4px 12px 12px 12px;
	overflow: hidden;
	box-sizing: border-box;
}
</style>
